import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateConfigurationTemplateName } from '@api/configurationTemplates';

import { TConfigurationTemplateUpdateNameDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONFIGURATION_TEMPLATES, CONFIGURATION_TEMPLATES_UPDATE_NAME } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConfigurationTemplateUpdateNameReturned {
	isLoadingUpdateName: boolean;
	updateName: UseMutateFunction<any, any, TConfigurationTemplateUpdateNameDTO, any>;
}

const useMutateConfigurationTemplateUpdateName = (
	onSuccess?: () => void,
): IUseMutateConfigurationTemplateUpdateNameReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutateAsync,
		isLoading,
	} = useMutation<TConfigurationTemplateUpdateNameDTO>({
		mutationKey: [CONFIGURATION_TEMPLATES_UPDATE_NAME],
		mutationFn: updateConfigurationTemplateName,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.updateTemplateName,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([CONFIGURATION_TEMPLATES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingUpdateName: isLoading,
		updateName: mutateAsync,
	};
};

export default useMutateConfigurationTemplateUpdateName;
